import { idToStrongId } from "@oysterhr/common"
import { generatePath } from "react-router-dom"
import {
  NAMESPACE_FOR_TYPE,
  URL_COMPANY_PREFIX,
  URL_STAFF_PREFIX,
  URL_TM_PREFIX,
} from "./constants"

export const staffBasePath = ({
  scope,
  path,
  id,
  query,
  hash,
}: {
  scope?: string
  path?: string
  id?: string
  query?: string
  hash?: string
} = {}) => {
  const fullPath = generatePath(`/${URL_STAFF_PREFIX}/:scope/:id/*`, {
    scope: scope || "",
    id: idToStrongId(id || ""),
    "*": path || "",
  })
  const queryOrHash = [query ? `?${query}` : "", hash ? `#${hash}` : ""].join("")

  return `${fullPath}${queryOrHash}`
}

export const companyBasePath = ({
  companyId,
  path,
  query,
  hash,
  bypassCompanyId = false,
}: {
  companyId?: string
  path?: string
  query?: string
  hash?: string
  bypassCompanyId?: boolean
} = {}) => {
  const storedCompanyStrongId = window.localStorage.getItem("selectedAccountAspect")
  const companyStrongId = idToStrongId(companyId || storedCompanyStrongId || "")
  const basePath =
    companyStrongId && !bypassCompanyId ? `/${URL_COMPANY_PREFIX}/:companyStrongId/*` : "/*"
  const fullPath = generatePath(basePath, { companyStrongId, "*": path || "" })
  const queryOrHash = [query ? `?${query}` : "", hash ? `#${hash}` : ""].join("")

  return `${fullPath}${queryOrHash}`
}

export const teamMemberBasePath = ({
  engagementId,
  path,
  query,
  hash,
  bypassEngagementId,
}: {
  engagementId?: string
  path?: string
  query?: string
  hash?: string
  bypassEngagementId?: boolean
} = {}) => {
  const storedEngagementId = window.localStorage.getItem("selectedAccountAspect")
  const storedEngagementType =
    window.localStorage.getItem("selectedAccountAspectType") || "Fallback"
  const engagementStrongId = idToStrongId(engagementId || storedEngagementId || "")
  const namespace = NAMESPACE_FOR_TYPE[storedEngagementType] || URL_TM_PREFIX
  const basePath =
    engagementStrongId && !bypassEngagementId ? `/${namespace}/:engagementStrongId/*` : "/*"
  const fullPath = generatePath(basePath, { engagementStrongId, "*": path || "" })
  const queryOrHash = [query ? `?${query}` : "", hash ? `#${hash}` : ""].join("")

  return `${fullPath}${queryOrHash}`
}
